module.exports = __webpack_public_path__ + "img/multiverse-theories-cover.671f7882.jpg";